// extracted by mini-css-extract-plugin
module.exports = {"select":"inputs-module--select--1JMI9","caret":"inputs-module--caret--1c1mm","switch":"inputs-module--switch--1RqLM"};